import React from 'react';
import { motion } from 'framer-motion';
import { Map, ArrowRight } from 'lucide-react';
import { RADIUS } from '../../../config/designTokens';
interface JourneyEmptyStateProps {
  onNavigate: (view: string) => void;
}
export function JourneyEmptyState({
  onNavigate
}: JourneyEmptyStateProps) {
  return <div className="flex flex-col items-center text-center pt-12 pb-24 px-4 relative z-10" data-id="element-1970" data-mp="3l09qnncofx">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} className="max-w-sm w-full" data-id="element-1971" data-mp="3s754ivmpgldh">
        
        <div className="relative w-32 h-32 mx-auto mb-6" data-id="element-1972" data-mp="3n9llzjiz5mfq">
          <div className="absolute inset-0 bg-blue-100 rounded-full animate-pulse" data-id="element-1973" data-mp="3i9h9s5p3ndvb" />
          <div className="absolute inset-2 bg-blue-50 rounded-full flex items-center justify-center border-4 border-white shadow-sm" data-id="element-1974" data-mp="3da4mjjubg4s7">
            <Map className="w-12 h-12 text-blue-400" data-id="element-1975" data-mp="1gg9tasxr2q7u" />
          </div>
        </div>

        <h2 className="text-2xl font-black text-slate-800 mb-3" data-id="element-1976" data-mp="1bj9kwbdfhbdk">
          Jouw reis begint hier!
        </h2>
        <p className="text-slate-600 font-medium mb-8 leading-relaxed" data-id="element-1977" data-mp="inz847vroggl">
          Je hebt nog geen vaardigheden geoefend. Zodra je begint, verschijnt
          hier jouw persoonlijke avonturenpad.
        </p>

        <button onClick={() => onNavigate('modules')} className={`w-full py-4 bg-blue-500 text-white font-black text-lg ${RADIUS.button} shadow-md hover:bg-blue-600 active:scale-95 transition-all flex items-center justify-center gap-2`} data-id="element-1978" data-mp="8t7bb6a0dxmv">
          
          Start je reis
          <ArrowRight className="w-5 h-5" data-id="element-1979" data-mp="16dti8hopbqx5" />
        </button>
      </motion.div>
    </div>;
}